
import React, { Children, useState } from 'react';
import './document.css';

const Document = ({ title, name, nam2, nam3, children }) => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>
      <div>
        <div className="title_documentacion">
          {title}
          <div className="name_documentacion">
            {name}
          </div>
          <div className="name_documentacion">
            {nam2}
          </div>
          <div className="name_documentacion">
            {nam3}
          </div>
        </div>
        <div className="container_document">
          <div className="code">
            {children}
          </div>
        </div>
      </div>
    </>

  )
}

export default Document;